// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrimaryButtons_primary-btn__8c19o {
  border-radius: 0.8rem;
  background-color: var(--primary-color);
  transition: background-color 0.3s ease-out;
  font-size: var(--text-base);
  font-weight: 500;
  line-height: 2.6rem;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 3rem;
}

.PrimaryButtons_primary-btn__8c19o:hover {
  background-color: var(--blue-extra-dark);
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/PrimaryButton/PrimaryButtons.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,0CAA0C;EAC1C,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".primary-btn {\n  border-radius: 0.8rem;\n  background-color: var(--primary-color);\n  transition: background-color 0.3s ease-out;\n  font-size: var(--text-base);\n  font-weight: 500;\n  line-height: 2.6rem;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  gap: 3rem;\n}\n\n.primary-btn:hover {\n  background-color: var(--blue-extra-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-btn": `PrimaryButtons_primary-btn__8c19o`
};
export default ___CSS_LOADER_EXPORT___;
